import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeLines"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H14V6H2V4ZM17 4H22V6H17V4ZM2 11H9V13H2V11ZM12 11H22V13H12V11ZM2 18H11V20H2V18ZM14 18H22V20H14V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeLines;
